import { render, staticRenderFns } from "./LangButtons.vue?vue&type=template&id=ac6da452&scoped=true"
import script from "./LangButtons.vue?vue&type=script&lang=js"
export * from "./LangButtons.vue?vue&type=script&lang=js"
import style0 from "./LangButtons.vue?vue&type=style&index=0&id=ac6da452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6da452",
  null
  
)

export default component.exports